import BigNumber from 'bignumber.js'
import { weiToEth, allTokensDict } from 'lottery/constants'
import { uriToHttp } from 'lottery/getTokenList'

export const getTokenMetaFromAddress = (address) =>
  allTokensDict[address.toLowerCase()]

export const getPoolTokenSymbol = (pool) =>
  getTokenMetaFromAddress(pool.token).symbol

export const getPoolRewardText = (pool) =>
  `${weiToEth(BigNumber(pool.reward), getTokenMetaFromAddress(pool.token).decimals)} ${getPoolTokenSymbol(pool)}`

export const getPoolBalanceText = (pool) =>
  `${weiToEth(BigNumber(pool.balance)).toFixed(4)} ${getPoolTokenSymbol(pool)}`

export const getPoolTokenLogoURL = (pool) => {
  const token = getTokenMetaFromAddress(pool.token)
  return token ? uriToHttp(token.logoURI)[0] : null
}

export const getTotalBonusTickets = (pool, purchaseSize) => {
  let weightBalance = weiToEth(BigNumber(pool.weightBalance))
  let bonus = 0
  for (let i = 0; i < purchaseSize; i++) {
    if (weightBalance > 0) {
      let _bonus = weightBalance / Number(pool.tickets)
      bonus += _bonus
      weightBalance = _bonus
    }
  }

  return bonus.toFixed(4)
}

export const getNextTicketBonus = (pool) =>
  (weiToEth(BigNumber(pool.weightBalance)) / pool.tickets).toFixed(4)

export const getDrawBonus = async (pool, poolsContract) => {
  if (poolsContract) {
    const bonusrate = await poolsContract.methods.drawerBonusRate().call()
    console.log('bonusrate: ', bonusrate)
    return (
      (weiToEth(BigNumber(pool.weightBalance)) * bonusrate) /
      100000
    ).toFixed(4)
  }
  return 0
}

export const getTokenEtherFromWeiByAddress = (token, amount) =>
  BigNumber(10 ** token.decimals)
    .times(BigNumber(amount))
    .toFixed(0)

export const isUnnamed = (pool) =>
  pool && (pool.name === 'undefined' || pool.name === '')
